import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RuleCommentModel, RuleModel, RuleStipModel } from '../model/rule.model';
import { RuleService } from '../service/rule.service';
import { VIEW_COMMENTS_MODE } from '../model/constants';

@Component({
	selector: 'cv-rule-comment-stip-view-component',
	templateUrl: './rule-comment-stip-view.component.html',
	styleUrls: ['./rule-comment-stip-view.component.scss']
})
export class RuleCommentStipViewComponent implements OnInit {
	@Input() viewMode: VIEW_COMMENTS_MODE;
	@Input() rule: RuleModel;
	@Input() disableAdd: boolean;
	@Output() addComment: EventEmitter<RuleModel> = new EventEmitter<RuleModel>();
	@Output() addStip: EventEmitter<RuleModel> = new EventEmitter<RuleModel>();
	@Output() deleteComments: EventEmitter<RuleCommentModel[]> = new EventEmitter<RuleCommentModel[]>();
	@Output() deleteStips: EventEmitter<RuleStipModel[]> = new EventEmitter<RuleStipModel[]>();
	@Output() closed: EventEmitter<any> = new EventEmitter<any>();
	public comments: RuleCommentModel[];
	stips: RuleStipModel[];
	selectedItems: Array<RuleCommentModel | RuleStipModel>;
	VIEW_COMMENTS_MODE = VIEW_COMMENTS_MODE;

	constructor(private ruleService: RuleService) {
		this.comments = [];
		this.stips = [];
		this.selectedItems = [];
		this.viewMode = VIEW_COMMENTS_MODE.COMMENTS;
	}

	ngOnInit(): void {
		this.comments = this.ruleService.sortRuleCommentsByDescDate(this.rule.notes.filter(n => !n.vendor));
		this.stips = this.ruleService.sortStipsbyDescDate(this.rule.stips);
	}

	/**
	 * On Add comment.
	 */
	public onAdd(): void {
		if (this.viewMode === VIEW_COMMENTS_MODE.COMMENTS) {
			this.addComment.emit(this.rule);
		} else {
			this.addStip.emit(this.rule);
		}
	}

	/**
	 * On Delete comments or stips.
	 */
	onDelete(): void {
		if (this.viewMode === VIEW_COMMENTS_MODE.COMMENTS) {
			this.deleteComments.emit(this.selectedItems as RuleCommentModel[]);
		} else {
			this.deleteStips.emit(this.selectedItems as RuleStipModel[]);
		}
	}

	/**
	 * On Cancel/Close panel form.
	 */
	public onCancel(): void {
		this.closed.emit();
	}

	/**
	 * Clear out the current selection and Toggles the view mode.
	 */
	toggleViewMode(): void {
		this.selectedItems = [];
		this.viewMode = (this.viewMode === VIEW_COMMENTS_MODE.COMMENTS ? VIEW_COMMENTS_MODE.STIPS : VIEW_COMMENTS_MODE.COMMENTS);
	}

	/**
	 * Update Items selection list
	 * @param $event
	 */
	onItemSelected($event: any): void {
		if ($event.value) {
			this.selectedItems.push($event.item);
		} else {
			this.selectedItems = this.selectedItems.filter(item => item.id !== $event.item.id || item.created !== $event.item.created);
		}
	}

	/**
	 * If we are on Stips view, check if rule can add stips or not.
	 */
	canAddStips(): boolean {
		if (this.viewMode === VIEW_COMMENTS_MODE.STIPS) {
			return this.rule.canAddStips;
		}
		return true;
	}
}
